import apiCallReducer from './apiReducer';

const apiReducers = {
  apiCall: apiCallReducer,
};

export { apiReducers };
